import type { Session } from "@supabase/supabase-js"
import { queryClient } from "@/lib/queryClient"
import { isOfflineSession, readOfflineAuthSnapshot } from "@/lib/offlineAuth"

const SESSION_QUERY_KEY = ["auth", "session"] as const

/**
 * Synchronously read the Supabase session mirrored into the query cache by
 * AuthProvider's onAuthStateChange listener. Never hits the network.
 */
export function getCachedSession(): Session | null {
  const session =
    queryClient.getQueryData<Session | null>(SESSION_QUERY_KEY) ?? null
  return isOfflineSession(session) ? null : session
}

/**
 * Resolve the current user's id from local state only. Used on hot paths
 * (e.g. form submit) where we must never await a token refresh that could
 * stall under poor reception.
 */
export async function getCachedUserId(): Promise<string | null> {
  const cached = getCachedSession()
  if (cached?.user.id) return cached.user.id
  const snapshot = await readOfflineAuthSnapshot()
  return snapshot?.userId ?? null
}
